var exports = {
  "jw": "MessageThreadChip.module__chip___YVJJMG",
  "nM": "MessageThreadChip.module__row___YVJJMG",
  "UU": "MessageThreadChip.module__name___YVJJMG",
  "U9": "MessageThreadChip.module__count___YVJJMG",
  "VH": "MessageThreadChip.module__preview___YVJJMG",
};

module.exports = exports;
